import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FunctionalDivisionList from '@/views/downLoadCenter/functionalDivisionList.vue';
import startedByme from '@/views/cardSystem/saleToos/projectDelivery/startedByme.vue';
import myToDo from '@/views/cardSystem/saleToos/projectDelivery/myToDo.vue';
import myReview from '@/views/cardSystem/saleToos/projectDelivery/myReview.vue';
import allToDo from '@/views/cardSystem/saleToos/projectDelivery/allToDo.vue';
import materialReceiveList from '@/views/downLoadCenter/materialReceiveList.vue';
import createDeliveryCountMixin from '@/views/cardSystem/saleToos/projectDelivery/deliveryCountMixin';
export default {
  name: 'artilleryFirelist',
  components: {
    FunctionalDivisionList: FunctionalDivisionList,
    startedByme: startedByme,
    myToDo: myToDo,
    myReview: myReview,
    allToDo: allToDo,
    materialReceiveList: materialReceiveList
  },
  // 角标计数逻辑与项目交付页面共用，计数参数取自 defaultForms，不依赖子组件挂载
  mixins: [createDeliveryCountMixin({
    myReview: ['/orders/project-delivery/my-review', '/user/project-ticket/my-audit'],
    myToDo: ['/orders/project-delivery/my-to-do', '/user/project-ticket/my-to-do'],
    allToDo: ['/orders/project-delivery/all-to-do', '/user/project-ticket/all-to-do']
  })],
  data: function data() {
    return {
      activeTab: '1',
      lastActiveTab: '',
      tabs: [{
        name: '1',
        label: '我发起的申请',
        permission: '/orders/project-delivery/initiated-by-me',
        ticketPermission: '/user/project-ticket/ticket-initiated-by-me'
      }, {
        name: '3',
        label: '我的待审核',
        permission: '/orders/project-delivery/my-review',
        ticketPermission: '/user/project-ticket/my-audit'
      }, {
        name: '2',
        label: '我的待办',
        permission: '/orders/project-delivery/my-to-do',
        ticketPermission: '/user/project-ticket/my-to-do'
      }, {
        name: '5',
        label: '全部待办',
        permission: '/orders/project-delivery/all-to-do',
        ticketPermission: '/user/project-ticket/all-to-do'
      }, {
        name: '4',
        label: '职能部门分工',
        permission: '/orders/project-delivery/division-of-labor'
      }, {
        name: '6',
        label: '物料领取',
        permission: '/material/top-tab/index'
      }]
    };
  },
  created: function created() {
    this.setDefaultActiveTab();
  },
  methods: {
    // 顶部 tab 切换：只刷新点击 tab 的计数（物料领取/职能部门分工无计数），重复点击当前 tab 不请求
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === this.lastActiveTab) return;
      this.lastActiveTab = tab.name;
      var nameMap = {
        '2': 'myToDo',
        '3': 'myReview',
        '5': 'allToDo'
      };
      this.getCountsForTab(nameMap[tab.name]);
    },
    setDefaultActiveTab: function setDefaultActiveTab() {
      var _this = this;
      var visibleTabs = this.tabs.filter(function (tab) {
        return _this.$hasBtnRoles(tab.permission) || tab.ticketPermission && _this.$hasBtnRoles(tab.ticketPermission);
      });
      this.activeTab = visibleTabs.length ? visibleTabs[0].name : '';
      this.lastActiveTab = this.activeTab;
    }
  }
};